<template>
  <vue-transmit class="d-flex w-100"
    v-bind="options"
    :upload-area-classes="['bg-faded', 'w-100']"
    :ref="transmitRef"
    :params="params"
    :max-file-size="maxFileSize"
    :acceptedFileTypes="acceptedFileTypes"
    @error="handleError"
    @added-file="$emit('added-file', arguments[0])"
    @processing="$emit('processing', arguments[0])"
    @success="$emit('success', arguments[0], arguments[1], arguments[2])">

    <slot></slot>

    <!-- Scoped slot -->
    <template slot="files" slot-scope="props">
      <slot name="files" :files="props.files"></slot>
    </template>
  </vue-transmit>
</template>

<script>
  import { assign } from 'lodash'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    props: {
      name: {
        type: String,
        default: 'media'
      },

      url: {
        type: String,
        required: true
      },

      maxFileSize: {
        type: Number,
        default: 200
      },

      method: {
        type: String,
        default: 'POST'
      },

      single: {
        type: Boolean,
        default: true
      },

      transmitRef: {
        type: String,
        default: 'TransmitRef'
      },

      acceptedFileTypes: {
        type: Array,
        default: () => {
          return []
        }
      },

      params: {
        type: Object,
        default () { return {} }
      },

      transmitOptions: {
        type: Object,
        default () {
          return {
            withCredentials: true,
            clickable: false
          }
        }
      }
    },

    data () {
      return {
        headers: {}
      }
    },

    computed: {
      ...mapGetters({
        token: 'auth/token'
      }),

      options () {
        return assign(this.transmitOptions, {
          url: this.url,
          method: this.method,
          headers: {
            Authorization: `Bearer ${this.token || null}`
          }
        })
      }
    },

    methods: {
      ...mapActions({
        setError: 'errors/setError',
        pushGlobalError: 'errors/pushGlobalError'
      }),

      handleError (file, message, xhr) {
        if (file.status === 'error') {
          this.pushGlobalError([{ message: message }])
        }

        if (xhr && xhr.status === 422) {
          /**
           * Validation error
           * As the default behaviour we will add the error to a "component" with the name of the field
           */
          try {
            let error = JSON.parse(xhr.response)

            console.log(error)

            this.setError(['UnprocessableEntity', error])
          } catch (e) {
            console.error(e)

            this.pushGlobalError([{ message: 'Houve um erro ao identificar o problema com o upload' }])
          }
        }

        this.$emit('error', arguments[0], arguments[1], arguments[2])
      }
    },

    filters: {
      json (value) {
        return JSON.stringify(value, null, 2)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/FileUploader.vue